import { withStyles } from '@material-ui/core';
import React from "react"
const styles = theme => ({
  videoContainer: {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    paddingTop: '56.25%' /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
  },
  responsiveIframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: '100%',
    height: '100%',
  }
});

const Video = ({ classes, src, title, ...props }) => (
  <div className={classes.videoContainer}>
    <iframe 
      className={classes.responsiveIframe}
      src={`${src}?rel=0`}
      title={title} 
      frameborder="0" 
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowfullscreen></iframe>
  </div>
)
export default withStyles(styles)(Video)